import React from "react";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <a href="#home" className="nav-link">Inicio</a>
      <a href="#about" className="nav-link">Envios</a>
      <a href="#services" className="nav-link">Stock</a>
      <a href="#contact" className="nav-link">Contacto</a>
      <a href="https://api.whatsapp.com/message/PNFAQ7L6HSEDK1?autoload=1&app_absent=0" className="nav-link store-link" target="_blank" rel="noopener noreferrer">
        Tienda
      </a>
    </nav>
  );
}

export default Navbar;
